module.exports = __webpack_public_path__ + "img/响应式详情Y03B.e401e816.jpg";